import { ORG_HEADER, ORG_QUERY } from '@af/shared';

/**
 * The company this browser tab works in. Kept in sessionStorage (per tab, survives reloads) and sent
 * with every API request as `x-af-org`, so switching company in one tab never redirects the actions
 * of another tab. The server checks membership (403 `not_a_member` → the pin is dropped).
 */
const KEY = 'af:org';

export const activeOrg = {
  get(): string | null {
    try {
      return globalThis.sessionStorage?.getItem(KEY) ?? null;
    } catch {
      return null;
    }
  },
  set(id: string) {
    try {
      globalThis.sessionStorage?.setItem(KEY, id);
    } catch {
      /* ignore: falls back to the session's company */
    }
  },
  clear() {
    try {
      globalThis.sessionStorage?.removeItem(KEY);
    } catch {
      /* ignore */
    }
  },
};

/** Header that pins a request to this tab's company (empty when not pinned yet). */
export function orgHeaders(): Record<string, string> {
  const id = activeOrg.get();
  return id ? { [ORG_HEADER]: id } : {};
}

/** Append the pin to a GET URL used where headers can't be sent (`<img src>`, downloads). */
export function withOrgQuery(url: string): string {
  const id = activeOrg.get();
  if (!id) return url;
  return `${url}${url.includes('?') ? '&' : '?'}${ORG_QUERY}=${encodeURIComponent(id)}`;
}
